type PhoneTypes = { [name: string]: string };

const PHONE_TYPES: PhoneTypes = {
  mobile: 'Mobile',
  'Possible Cell Phone': 'Possible Mobile',
  L: 'Landline',
  home_phone: 'Home Phone',
  work_phone: 'Work Phone',
  'Possible non-DA': 'Possible Spam',
  work_fax: 'Work Fax',
  professional: 'Work Phone',
  'Current DA': 'Landline',
  'Possible Ported Cell Phone': 'Possible Ported Mobile',
  Mobile: 'Mobile',
  W: 'Possible Mobile',
  M: 'Possible Mobile',
  personal: 'Possible Mobile',
  work: 'Work Phone',
  home: 'Home Phone',
};

const phoneType = (type: string): string => {
  return PHONE_TYPES[type] || type;
};

const generateSearchVolumeText = (numSearches: number): string => {
  if (numSearches >= 20) {
    return 'Very high';
  }
  if (numSearches > 10) {
    return 'High';
  }
  return 'Low';
};

export { generateSearchVolumeText, phoneType };
